import { Tenant } from '@/types/common';

export const isCaymanTenant = (tenant?: Tenant): boolean => {
  return tenant === Tenant.Cayman;
};

export const isGuyanaTenant = (tenant?: Tenant): boolean => {
  return tenant === Tenant.Guyana;
};

export const isSintMaartenTenant = (tenant?: Tenant): boolean => {
  return tenant === Tenant.SintMaarten;
};
